module.exports = __webpack_public_path__ + "static/media/Nov_2025_5.3f057ebb.webp";